export default __webpack_public_path__ + "static/media/waste-heat-recovery.72e7fe61.jpg";